import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 医師一覧
 *
 * 自分が担当している病院の医師一覧を返す
 */
export class FetchDoctor implements APIRequest<Monitaro.FetchDoctorResponse> {
  response: Monitaro.FetchDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/doctors`
  }
}

/**
 * 医師データの取得
 *
 * 自分が所属している病院の病院管理者の詳細を取得する&lt;br&gt;
 * 所属していない病院の病院管理者IDが指定された場合はステータス404
 */
export class GetDoctor implements APIRequest<Monitaro.GetDoctorResponse> {
  response: Monitaro.GetDoctorResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(doctor: string) {
    this.path = `/doctors/${doctor}`
  }
}

/**
 * 医師データのアポイントデータを取得する
 *
 * 自分が所属している病院の病院管理者のアポイントメントデータを取得する
 * 所属していない病院の病院管理者IDが指定された場合はステータス404
 */
export class GetDoctorAppointment implements APIRequest<Monitaro.GetDoctorAppointmentResponse> {
  response: Monitaro.GetDoctorAppointmentResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: any
  constructor(doctor: string, date: string) {
    this.params = { date }
    this.path = `/doctors/appointments/${doctor}`
  }
}
